import React from 'react';
import { useTranslation } from 'react-i18next';
import { KpiTile } from '../patterns';
import type { SprayKpis } from '../../utils/sprayDashboardMath';

export interface SprayKpiRowProps { kpis: SprayKpis }

export const SprayKpiRow: React.FC<SprayKpiRowProps> = ({ kpis }) => {
  const { t } = useTranslation();
  return (
    <div className="pat-kpi-row" data-testid="spray-kpi-row">
      <KpiTile
        primary
        label={t('spray.dashboard.kpi.activePrograms')}
        value={kpis.activeProgramsCount}
        delta={t('spray.dashboard.kpi.activePrograms.delta', { running: kpis.runningSessions })}
      />
      <KpiTile
        label={t('spray.dashboard.kpi.upcomingSessions30d')}
        value={kpis.upcomingCount}
        delta={t('spray.dashboard.kpi.upcomingSessions30d.delta')}
      />
      <KpiTile
        alert={kpis.operatorsExpiringCount > 0}
        label={t('spray.dashboard.kpi.operatorsExpiring')}
        value={kpis.operatorsExpiringCount}
        delta={t('spray.dashboard.kpi.operatorsExpiring.delta')}
      />
      <KpiTile
        alert={kpis.machinesDueCount > 0}
        label={t('spray.dashboard.kpi.machinesDue')}
        value={kpis.machinesDueCount}
        delta={t('spray.dashboard.kpi.machinesDue.delta')}
      />
    </div>
  );
};

export default SprayKpiRow;
